import { NgModule } from '@angular/core';
import { MailPopinComponent } from './mail-popin.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { QuillModule } from 'ngx-quill';
import { CommonModule } from '@angular/common';
import { LoaderModule } from '../loader/loader.module';

@NgModule({
  imports: [
    TranslateModule,
    FormsModule,
    QuillModule.forRoot(),
    ReactiveFormsModule,
    CommonModule,
    LoaderModule,
  ],
  declarations: [MailPopinComponent],
  exports: [MailPopinComponent],
})
export class MailPopinModule {}
